import Cookies from 'js-cookie';

const getCookieOptions = () => {
  if (typeof window === 'undefined') { return {}; }

  const hostname = window.location.hostname;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isKatonDomain = hostname.endsWith('.katon360.com') || hostname === 'katon360.com';

  return {
    expires: 7,
    path: '/',
    ...(isKatonDomain ? { domain: '.katon360.com' } : {}),
    ...(isLocal ? {} : { secure: true, sameSite: 'Lax' as const }),
  };
};

export function SetCookie(name: string, val: any): void {
  Cookies.set(name, JSON.stringify(val), getCookieOptions());
}

export function GetCookie(name: string) {
  const value = Cookies.get(name);
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return value || null;
  }
}

export function RemoveCookie(name: string): void {
  Cookies.remove(name, getCookieOptions());
}

